import topic from "dojo/topic";
import locale from "csi/locale";
import MessageDialog from "csi/widget/MessageDialog";

//TODO: create a real interface for parameters
type MessageDialogParams = any;

function showDialog(params: MessageDialogParams): any {
	var dialog = new MessageDialog(params);
	dialog.show();
	return dialog;
}

export = {
	showDialog,

	errorDialog(params: MessageDialogParams): any {
		params.materialIcon = params.materialIcon || MessageDialog.ICON_ERROR;
		params.buttons = params.buttons || [MessageDialog.BUTTON_OK];
		params.title = params.title || locale.resource("ERROR");
		return showDialog(params);
	},

	error(s: string): void {
		topic.publish("/csi/message/error", s);
	},

	hide(bProgressOnly?: boolean): void {
		topic.publish("/csi/message/hide", bProgressOnly);
	},

	progress(s: string): void {
		topic.publish("/csi/message/progress", s);
	},

	success(s: string): void {
		topic.publish("/csi/message/success", s);
	},

	showInfo(s: string): void {
		topic.publish("/csi/message/showInfo", s);
	},

	hideInfo(s: string): void {
		topic.publish("/csi/message/hideInfo", s);
	},
};
